"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _cssScrollHelper = require("../helpers/cssScrollHelper");

var _galleryComponent = require("../galleryComponent");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var ScrollIndicator =
/*#__PURE__*/
function (_GalleryComponent) {
  _inheritsLoose(ScrollIndicator, _GalleryComponent);

  function ScrollIndicator(props) {
    var _this;

    _this = _GalleryComponent.call(this) || this;
    _this.state = {
      scrollTop: 0,
      scrollLeft: 0
    };
    _this.debouncedOnScroll = _lodash["default"].debounce(props.onScroll, 50);
    return _this;
  }

  var _proto = ScrollIndicator.prototype;

  _proto.removeScrollListener = function removeScrollListener() {
    if (this.scrollEventListenerSet) {
      var scrollingElement = this.props.scrollingElement;

      try {
        scrollingElement.vertical().removeEventListener('scroll', this.onVerticalScroll);
      } catch (e) {//
      }

      try {
        var oneRow = this.props.oneRow;

        if (oneRow) {
          scrollingElement.horizontal().removeEventListener('scroll', this.onHorizontalScroll);
        }
      } catch (e) {//
      }

      this.scrollEventListenerSet = false;
    }
  };

  _proto.initScrollListener = function initScrollListener() {
    var _this2 = this;

    if (this.scrollEventListenerSet) {
      this.removeScrollListener();
    }

    this.scrollEventListenerSet = true;
    var scrollingElement = this.props.scrollingElement; //Horizontal Scroll

    this.onHorizontalScroll = function (e) {
      var target = e.currentTarget || e.target || e;
      var top = target && (target.scrollY || target.scrollTop || target.y);
      var left = target && (target.scrollX || target.scrollLeft || target.x);

      if (left >= 0) {
        _this2.setState({
          scrollTop: left,
          //todo use both scrollTop and scrollLeft
          scrollLeft: left
        });

        _this2.props.getMoreItemsIfNeeded(left);

        _this2.props.enableScrollPreload();

        _this2.debouncedOnScroll({
          top: top,
          left: left
        });
      }
    };

    try {
      scrollingElement.horizontal().addEventListener('scroll', this.onHorizontalScroll);
    } catch (e) {} //
    //Vertical Scroll


    this.onVerticalScroll = function (e) {
      var target = e.currentTarget || e.target || e;
      var top = target && (target.scrollY || target.scrollTop || target.y);
      var left = target && (target.scrollX || target.scrollLeft || target.x);

      if (top >= 0) {
        _this2.setState({
          scrollTop: top
        });

        _this2.props.getMoreItemsIfNeeded(top);

        _this2.props.enableScrollPreload();

        _this2.debouncedOnScroll({
          top: top,
          left: left
        });
      }
    };

    try {
      scrollingElement.vertical().addEventListener('scroll', this.onVerticalScroll);
    } catch (e) {//
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.removeScrollListener();
  };

  _proto.componentDidMount = function componentDidMount() {
    this.initScrollListener();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    this.initScrollListener();
  };

  _proto.render = function render() {
    var verticalScrollBase = !this.props.oneRow && this.props.scrollBase > 0 ? this.props.scrollBase : 0;
    var scrollTopWithoutBase = this.state.scrollTop - verticalScrollBase;
    var galleryDomId = this.props.galleryDomId;
    return _react["default"].createElement("div", {
      key: "css-scroll-indicator",
      "data-hook": "css-scroll-indicator",
      "data-scroll-base": verticalScrollBase,
      "data-scroll-top": this.state.scrollTop,
      className: _cssScrollHelper.cssScrollHelper.calcScrollClasses(galleryDomId, scrollTopWithoutBase),
      style: {
        display: 'none'
      }
    });
  };

  return ScrollIndicator;
}(_galleryComponent.GalleryComponent);

exports["default"] = ScrollIndicator;